import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-between px-4 py-3 mb-4 border rounded-lg",
  style: {"background-color":"#f0f7ff","border-color":"#a3c2f0"}
}
const _hoisted_2 = { class: "flex items-center gap-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-circle text-xl",
  style: {"color":"#4f8df9"}
}, null, -1)
const _hoisted_4 = {
  class: "font-semibold",
  style: {"color":"#4f8df9"}
}

import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import moment from 'moment'
import apiUseCase from '@/usecase/apiUseCase'


export default /*#__PURE__*/_defineComponent({
  __name: 'UpcomingRosterWarning',
  setup(__props) {

const upcomingRosters = ref(0)
const router = useRouter()
let pollingInterval: ReturnType<typeof setInterval> | null = null

const fetchDashboardRoster = async () => {
  try {
    const startDate = moment().format('YYYY-MM-DD HH:mm:ss')
    const endDate = moment().add(1, 'hour').format('YYYY-MM-DD HH:mm:ss')
    const response = await apiUseCase.get(`/roster/v2/Rosters/Dashboard?StartDate=${startDate}&EndDate=${endDate}`)
    if (!response.error) {
      upcomingRosters.value = response.result?.UpcomingRosters || 0
    }
  } catch (error) {
    console.error(error)
  }
}

const checkDisini = () => {
  router.push({ name: 'roster' })
}

onMounted(() => {
  fetchDashboardRoster()
  pollingInterval = setInterval(() => {
    fetchDashboardRoster()
  }, 60000)
})

onUnmounted(() => {
  if (pollingInterval) {
    clearInterval(pollingInterval)
  }
})

return (_ctx: any,_cache: any) => {
  return (upcomingRosters.value > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, " Ada " + _toDisplayString(upcomingRosters.value) + " jadwal bus yang belum diberangkatkan dalam 1 jam kedepan ", 1)
        ]),
        _createElementVNode("button", {
          onClick: checkDisini,
          class: "text-white px-4 py-2 rounded-md font-semibold text-sm cursor-pointer hover:opacity-90",
          style: {"background-color":"#4f8df9","border":"none","transition":"0.2s"}
        }, " Cek Jadwal ")
      ]))
    : _createCommentVNode("", true)
}
}

})